import React, { Component, useState, useEffect } from 'react';
import { connect } from "react-redux";

import Box from '../components/Box';
import Button from '../components/Button';

import '../css/Input.css';

const TransactionStatus = ({ transactions, transactionStack, getTxStatus }) => {
  const [ message, setMessage ] = useState(null);

  useEffect(() => {
    setMessage(getTxStatus());
  }, [transactions, transactionStack]);

  return message ? message : null;
}

class CreatePage extends Component
{
  render() {
    const { navBarHeight, navBarActive } = this.props;
    const style = navBarActive ? { background: '#F8F8F8' } : { top: navBarHeight, background: '#F8F8F8' };

    return (
      <div>
        <Box className='relative ma4 pv3 ph4' style={style}>
          <div>
            <div className='flex flex-wrap items-center'>
              <h1 className='times-new-roman fw4 mb2 f3 greenmod'>Create tokens</h1>
            </div>
            <div className=''><span className='link blue u'>Only the system owner</span> can use this function.</div>
            <p className='fw6 mt1 ml3-ns w-100'></p>
          </div>
          <div className='Forms'>
            <form onSubmit={this.props.handleSubmit}>
              <input
                type="text"
                placeholder="Jabra number"
                name="jabraNumber"
                onChange={this.props.handleChange}
                className='mv2 db v-mid focus-outline'
                style={{ padding: '1px', borderColor: '#ffffff', width: '30%', maxWidth: '250px' }}
              />
              <input
                type="text"
                placeholder="Start time"
                name="startDate"
                onChange={this.props.handleChange}
                className='v-mid focus-outline'
                style={{ padding: '1px', borderColor: '#ffffff', width: '30%', maxWidth: '250px' }}
              />
              <input
                type="text"
                placeholder="End time"
                name="endDate"
                onChange={this.props.handleChange}
                className='v-mid focus-outline'
                style={{ padding: '1px', borderColor: '#ffffff', width: '30%', maxWidth: '250px' }}
              />
              <Button type="submit" style={{ fontWeight: '400' }}>Create</Button>
              <div className='mv3'>Start time and End time must be multiplications of 30 minutes, yyyy/mm/dd HH:MM:SS.</div>
              <TransactionStatus
                transactions={this.props.transactions}
                transactionStack={this.props.transactionStack}
                getTxStatus={this.props.getTxStatus}
              />
            </form>
          </div>
        </Box>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default connect(mapStateToProps)(CreatePage);
